// HashtagCategoryList.js
'use strict';
import { connect } from 'react-redux';

import { TRENDING_HASHTAG_FEED } from '../RemoteConfigKeys.js';

import HashtagCategoryList from '../component/HashtagCategoryList.jsx';

import fetchTranslationByKey from '../action/fetchTranslationByKey.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (state, { category }) => {
  const trendingHashtagFeed = getRemoteConfigData(state, TRENDING_HASHTAG_FEED);
  return {
    meId: getMeData(state, 'id'),
    category,
    trendingHashtagFeed,
    hashtags: getListData(
      state,
      ['home', 'hashtags', trendingHashtagFeed],
      'itemIds'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchTranslationByKey: ({ groups }) =>
      dispatch(fetchTranslationByKey({ groups })),
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HashtagCategoryList);
